import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { versionChip, VersionChip } from '../version-status.util';
import type { RulePackageVersion } from 'src/app/core/services/rules-api.service';

@Component({
  selector: 'app-version-history-table',
  standalone: true,
  imports: [CommonModule, IconModule],
  templateUrl: './version-history-table.component.html',
})
export class VersionHistoryTableComponent {
  @Input() versions: RulePackageVersion[] = [];
  @Input() activeVersionId: string | null = null;
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 20;
  @Input() loading = false;
  @Input() busyId: string | null = null;

  @Output() view = new EventEmitter<RulePackageVersion>();
  @Output() publish = new EventEmitter<RulePackageVersion>();
  @Output() restore = new EventEmitter<RulePackageVersion>();
  @Output() pageChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.total / this.pageSize));
  }

  chip(v: RulePackageVersion): VersionChip {
    return versionChip(v, this.activeVersionId);
  }

  prev(): void {
    if (this.page > 1) this.pageChange.emit(this.page - 1);
  }

  next(): void {
    if (this.page < this.totalPages) this.pageChange.emit(this.page + 1);
  }
}
